import React from 'react';
import './Recruit.scss'
import { RecruitSwiper } from '@/components/mixins'
class Recruit extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      bannerImages: [
        { imgPath: require("img/recruit/recruitbannerbg.png"), imgHDPath: `${require("img/recruit/recruitbannerbg.png")} 1x,${require("img/recruit/recruitbannerbg@2x.png")} 2x,${require("img/recruit/recruitbannerbg@3x.png")} 3x`, attachURL: "/" }
      ],
      secietyImages: [
        { imgPath: require("img/recruit/secietypic01.png"), imgHDPath: `${require("img/recruit/secietypic01.png")} 1x,${require("img/recruit/secietypic01@2x.png")} 2x,${require("img/recruit/secietypic01@3x.png")} 3x`, attachURL: "/" },
        { imgPath: require("img/recruit/secietypic02.png"), imgHDPath: `${require("img/recruit/secietypic02.png")} 1x,${require("img/recruit/secietypic02@2x.png")} 2x,${require("img/recruit/secietypic02@3x.png")} 3x`, attachURL: "/" },
        { imgPath: require("img/recruit/secietypic03.png"), imgHDPath: `${require("img/recruit/secietypic03.png")} 1x,${require("img/recruit/secietypic03@2x.png")} 2x,${require("img/recruit/secietypic03@3x.png")} 3x`, attachURL: "/" }
      ],
      schoolImages: [
        { imgPath: require("img/recruit/schoolpic01.png"), imgHDPath: `${require("img/recruit/schoolpic01.png")} 1x,${require("img/recruit/schoolpic01@2x.png")} 2x,${require("img/recruit/schoolpic01@3x.png")} 3x`, attachURL: "/" },
        { imgPath: require("img/recruit/schoolpic02.png"), imgHDPath: `${require("img/recruit/schoolpic02.png")} 1x,${require("img/recruit/schoolpic02@2x.png")} 2x,${require("img/recruit/schoolpic02@3x.png")} 3x`, attachURL: "/" },
        { imgPath: require("img/recruit/schoolpic03.png"), imgHDPath: `${require("img/recruit/schoolpic03.png")} 1x,${require("img/recruit/schoolpic03@2x.png")} 2x,${require("img/recruit/schoolpic03@3x.png")} 3x`, attachURL: "/" }
      ],
      schoolFlowImages: [
        { imgPath: require("img/recruit/zplc-pic.png"), imgHDPath: `${require("img/recruit/zplc-pic.png")} 1x,${require("img/recruit/zplc-pic@2x.png")} 2x,${require("img/recruit/zplc-pic@3x.png")} 3x`, attachURL: "/" },

      ],

    }
  }
  render() {
    return (
      <main className="recruit">
        {/* <HeaderSwiper headerDataLists={this.state.bannerImages}></HeaderSwiper> */}
        <header className="recruit-header">
          <img src={require("img/recruit/recruitbannerbg.png")} alt="青云万里 矩步方行" className="header-img" />
          <p className="header-title">青云万里<br />矩步方行</p>
        </header>
        <section className="recruit-section">
          <p className="big-title">We Want You！</p>
          <div className="details-top">
            你将受到挑战，你将得到启发<br />无论你在这个大家庭从事什么工作<br />你都将成为非凡事业的其中一员
          </div>
          <p className="recruit-title">社会招聘</p>
          <RecruitSwiper headerDataLists={this.state.secietyImages} delay='1000'></RecruitSwiper>
          <p className="big-seciety-title">“青”睐你，只为你</p>
          <div className="details">
            青矩作为一个大家庭，它简单，向上，透明，宽容。<br />愿青矩伴你成长，祝你腾飞。<br />青矩，欢迎你的加入！<br />
            <a href="https://webapp.zhaopin.com/2026/hd/qjjsg0612084644116ZL82493/" alt="社会求职" target="_blank" rel="noopener noreferrer">
              <button className="recruit-btn">社会求职</button>
            </a>
          </div>
          <p className="recruit-title">校园招聘</p>
          <RecruitSwiper headerDataLists={this.state.schoolImages} delay='2000'></RecruitSwiper>
          <p className="big-seciety-title">遇见你，青矩</p>
          <div className="details">
            <p className="school-title">校招流程：</p>
            <div className="school-flow">
              {/* <span>1.网络申请</span>
              <span>2.线下宣讲&面试测评</span>
              <span>3.发放offer</span>
              <span>6.正式入职</span>
              <span>5.入职培训</span>
              <span>4.安排实习</span> */}
              {
                this.state.schoolFlowImages.map((item, index) =>
                  <img src={item.imgPath} alt="" key={index} srcSet={item.imgHDPath} width="100%" height="100%" />
                )
              }
            </div>
            <a href="https://campus.51job.com/greetec2027/" alt="校园求职" target="_blank" rel="noopener noreferrer">
              <button className="school-btn">校园求职</button>
            </a>
          </div>
        </section>
      </main>
    )
  }
}
export default Recruit;
